import { render, staticRenderFns } from "./StartupModal.vue?vue&type=template&id=524e6eed&scoped=true&"
import script from "./StartupModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./StartupModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./StartupModal.vue?vue&type=style&index=0&id=524e6eed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524e6eed",
  null
  
)

export default component.exports